import SmetaButton from "./MainPage/Tools/SmetaButton/SmetaButton";
import styles from "./serverUnavailable.module.css";

type ServerUnavailableProps = {
  onRetry: () => void;
};

// eslint-disable-next-line
const ServerUnavailable = ({ onRetry }: ServerUnavailableProps) => (
  <div className={styles.root}>
    <p className={styles.message}>Сервер не отвечает</p>
    <SmetaButton onClick={onRetry}>Повторить</SmetaButton>
  </div>
);

export default ServerUnavailable;
